export default __webpack_public_path__ + "static/media/risk_medium.75164417.svg";